// extracted by mini-css-extract-plugin
export default {"container":"LateralCanvas_container__d33o0","innerContainer":"LateralCanvas_innerContainer__f4uYZ"};